import { useEffect, useState } from "react";
import { api, formatBRL } from "../../lib/api";

export default function AdminGiftCards() {
  const [cards, setCards] = useState([]);
  useEffect(() => {
    api.get("/admin/gift-cards").then((r) => setCards(r.data));
  }, []);
  return (
    <div data-testid="admin-giftcards">
      <p className="overline text-[#A8A8A8] mb-1">Vendidos</p>
      <h1 className="font-display text-4xl mb-10">Gift Cards</h1>
      <div className="bg-white">
        <table className="w-full text-sm">
          <thead className="bg-[#FAF9F7] text-left">
            <tr>
              <th className="p-4 overline text-[#A8A8A8]">Código</th>
              <th className="p-4 overline text-[#A8A8A8]">Valor</th>
              <th className="p-4 overline text-[#A8A8A8]">Para</th>
              <th className="p-4 overline text-[#A8A8A8]">De</th>
              <th className="p-4 overline text-[#A8A8A8]">Status</th>
              <th className="p-4 overline text-[#A8A8A8]">Criado em</th>
            </tr>
          </thead>
          <tbody>
            {cards.map((c) => (
              <tr key={c.code} className="border-t border-[#E8E4DF]">
                <td className="p-4 font-mono text-xs">{c.code}</td>
                <td className="p-4">{formatBRL(c.amount)}</td>
                <td className="p-4">{c.metadata?.recipient_name || c.metadata?.recipient_email || "—"}</td>
                <td className="p-4 text-[#6B6B6B]">{c.metadata?.sender_name || "—"}</td>
                <td className="p-4"><span className="text-xs px-2 py-1 bg-[#F5EFE8]">{c.used ? "usado" : "ativo"}</span></td>
                <td className="p-4 text-xs text-[#6B6B6B]">{(c.created_at || "").slice(0, 10)}</td>
              </tr>
            ))}
            {cards.length === 0 && <tr><td colSpan="6" className="p-8 text-center text-[#A8A8A8]">Nenhum gift card vendido ainda.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
